export type Role = 'administrator' | 'operator' | 'viewer'

export type User = {
  id: string
  username: string
  role: Role
}

async function readError(response: Response, fallback: string) {
  const payload = await response.json().catch(() => ({})) as { error?: string }
  return payload.error ?? fallback
}

export async function loadCurrentUser() {
  const response = await fetch('/api/auth/me')
  if (response.status === 401) return null
  if (!response.ok) throw new Error(await readError(response, 'Session unavailable'))
  return response.json() as Promise<User>
}

export async function login(username: string, password: string) {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  })
  if (!response.ok) throw new Error(await readError(response, 'Invalid credentials'))
  return response.json() as Promise<User>
}

export async function changePassword(currentPassword: string, newPassword: string) {
  const response = await fetch('/api/auth/password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  })
  if (!response.ok) throw new Error(await readError(response, 'Password could not be changed'))
  return response.json() as Promise<User>
}

